"use client";
import { Auction, AuctionSettings } from "@prisma/client";
import React from "react";
import AuctionInfo from "./AuctionInfo";
import AuctionRandomImagePreview from "./AuctionRandomImagePreview";
import { Flex } from "@radix-ui/themes";

interface Props {
  auction: Auction;
  auctionSettings: AuctionSettings;
}

const AuctionBanner = ({ auction, auctionSettings }: Props) => {
  // AuctionRandomImagePreview will not be rendered on mobile
  return (
    <Flex
      className="flex-col items-center gap-0 md:flex-row md:mb-10 md:gap-6"
      justify="center"
      width="auto"
    >
      <AuctionInfo auction={auction} auctionSettings={auctionSettings} />
      <AuctionRandomImagePreview auction={auction} />
    </Flex>
  );
};

export default AuctionBanner;
